import { useState, useContext, useEffect } from "react";
import "./PendingChangesBar.scss";
import UIService from "../../../../services/UIService";
import OwButton from "../../../shared/OwButton/OwButton";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import UiContext from "../../../../contexts/UiContext";

type Props = {
    visible: boolean;
    saveFn: () => void;
    saveActive: boolean;
};

const PendingChangesBar = (props: Props) => {
    const uiContext = useContext(UiContext);

    const [lookupLeft, setLookupLeft] = useState(UIService.getLookupSize(uiContext.menuOpen, uiContext.menuIconMode, true).lookupLeft);
    const [lookupWidth, setLookupWidth] = useState(UIService.getLookupSize(uiContext.menuOpen, uiContext.menuIconMode, true).lookupWidth);

    useEffect(() => {
        const lookupDetails = UIService.getLookupSize(uiContext.menuOpen, uiContext.menuIconMode, true)

        setLookupLeft(lookupDetails.lookupLeft);
        setLookupWidth(lookupDetails.lookupWidth);

    }, [uiContext.menuOpen, uiContext.menuIconMode]);

    if (!props.visible) {
        return null;
    }

    return (
        <div className="PendingChangesBar text-center" style={{ width: lookupWidth, left: lookupLeft }}>
            <OwLabel title={"pending_changes"} noBottomMargin={true} />
            <OwButton
                title={"save"}
                className={"btn btn-primary btn-sm ms-5"}
                fn={props.saveFn}
                active={props.saveActive}
                disableOnActive={true}
            />
        </div>
    );
}

export default PendingChangesBar;
